/**
 * Normalizes a dynamic-render typeahead (or similar) control value to a single
 * non-empty string, or `null`.
 *
 * Handles:
 * - `null` / `undefined` / `''`
 * - Plain strings (trimmed; whitespace-only → `null`)
 * - Objects with `value`, `id`, or `name` string fields (first non-empty after trim wins)
 */
export function normalizeTypeaheadLikeString(value: unknown): string | null {
  if (value == null || value === '') {
    return null;
  }

  if (typeof value === 'string') {
    const t = value.trim();
    return t.length > 0 ? t : null;
  }

  if (typeof value === 'object') {
    const o = value as { value?: unknown; id?: unknown; name?: unknown };
    for (const key of ['value', 'id', 'name'] as const) {
      const v = o[key];
      if (typeof v === 'string') {
        const t = v.trim();
        if (t.length > 0) {
          return t;
        }
      }
    }
  }

  return null;
}
